module.exports = __webpack_public_path__ + "img/Officechair.d4d98518.svg";